import React from 'react'
import MaterialSymbol from '../material-symbol'

const InsertChartOutlined = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="insert_chart_outlined" {...props} />
))

InsertChartOutlined.displayName = 'InsertChartOutlined'

export default InsertChartOutlined
